var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.900253 6.4754C2.79419 4.54737 5.31187 3.4855 7.9899 3.4855C10.6654 3.4855 13.1818 4.54484 15.0758 6.46908L15.976 5.58398C15.2197 4.81504 14.3712 4.17616 13.4621 3.66227L14.6313 2.49308L13.7386 1.6004L12.2664 3.07262C11.1667 2.61555 9.99369 2.34661 8.78409 2.26201V0.333984H7.52146V2.24434C6.28283 2.29611 5.08081 2.54737 3.94949 2.98676L2.55808 1.59535L1.6654 2.48802L2.72222 3.54484C1.73232 4.07767 0.814394 4.76075 0 5.5903L0.900253 6.4754ZM15.0997 9.99561C13.2058 11.9236 10.6881 12.9855 8.0101 12.9855C5.33459 12.9855 2.81818 11.9249 0.924239 10.0007L0.0239868 10.8858C2.15656 13.0549 4.99368 14.2481 8.0101 14.2481C11.0303 14.2481 13.8674 13.0524 16 10.8807L15.0997 9.99561ZM11.4684 8.1509C11.4684 6.19383 9.87627 4.60165 7.9192 4.60165C5.96212 4.60165 4.37122 6.19383 4.37122 8.1509C4.37122 10.108 5.96339 11.7001 7.92046 11.7001C9.87753 11.7001 11.4684 10.1067 11.4684 8.1509ZM5.63384 8.15089C5.63384 6.89079 6.65909 5.86428 7.92046 5.86428C9.18182 5.86428 10.2071 6.88953 10.2071 8.15089C10.2071 9.41226 9.18182 10.4375 7.92046 10.4375C6.65909 10.4375 5.63384 9.411 5.63384 8.15089Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon-view.5796a92dd64109d4ce126d4f9687fdb1.svg";
export { ForwardRef as ReactComponent };